module.exports = __webpack_public_path__ + "static/about1-933d11b620a208ad3010d5657f48388d.jpg";